import React from 'react'
import styled from 'styled-components'
import { Typography } from '../../../Common'

export const StepTitle = ({ step, title }: StepTitleProps) => {
  return (
    <Container>
      <Number>{step}</Number>
      <Title>{title}</Title>
    </Container>
  )
}

type StepTitleProps = {
  title: string
  step: number | string
}

const Container = styled.div`
  display: flex;
  align-items: center;
`

const Number = styled.span.attrs({
  className: 'mr-5',
})`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.greyTitle};
  color: ${({ theme }) => theme.palette.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
`

const Title = styled(Typography).attrs({
  as: 'h2',
  variant: 4,
})`
  font-weight: normal;
  color: ${({ theme }) => theme.palette.greyTitle};
`
